<script lang="ts">
    // @ts-nocheck
    import tabIcon from "@/assets/vardplatsbestallning.svg";
    import BaseTab from "@/tabs/mixins/BaseTab.js";

    export default {
        // eslint-disable-next-line vue/multi-word-component-names
        name: "Receptforskrivning",
        tabName: "Ny förskrivning",
        extends: BaseTab,
        patientBound: true,
        icon: tabIcon,
        methods: {
            cancel(args?: { hasUnsavedData?: boolean } = {}) {
                this.closeTab(args.hasUnsavedData);
            },
        },
    };
</script>

<script setup lang="ts">
    import ReceptforskrivningDisplay from "@/tabs/Receptforskrivning/Forskrivning/Display/ReceptforskrivningDisplay.vue";
    import ReceptforskrivningForm from "@/tabs/Receptforskrivning/Forskrivning/Form/ReceptforskrivningForm.vue";
    import ReceptforskrivningSamling from "@/tabs/Receptforskrivning/Forskrivning/Samling/ReceptforskrivningSamling.vue";
    import ReceptforskrivningsmallarButton from "@/tabs/Receptforskrivning/Mall/ReceptforskrivningsmallarButton.vue";
    import Patientinfo from "@/tabs/Receptforskrivning/Patientinfo.vue";
    import { computed, onBeforeMount, onUnmounted, ref, toRefs, onMounted } from "vue";
    import { useStore } from "@/store";
    import emitter from "tiny-emitter/instance";

    const store = useStore();

    const props = withDefaults(
        defineProps<{
            tabId: number;
            receptforskrivningId?: string;
            // Är det en förnyelse av en förskrivning?
            fornya?: boolean;
        }>(),
        {
            fornya: false,
        }
    );

    const headerRef = ref();
    const formRef = ref();

    const { tabId, receptforskrivningId, fornya } = toRefs(props);

    const currentId = ref<string | undefined>(receptforskrivningId?.value);
    const step = ref<"form" | "display" | "list">("form");
    const editingSamling = ref(false);

    const hasUnsavedData = computed(() => {
        return formRef?.value?.hasUnsavedData() || store.getters["receptforskrivning/receptforskrivningar"].length;
    });

    const patientinfo = computed(() => {
        return store.getters["nll/patientinfo"];
    });

    const onAction = ({
        step: updatedStep,
        id,
        editingSamling: updatedEditingSamling,
    }: {
        step: "form" | "display" | "list";
        id?: string;
        editingSamling?: boolean;
    }) => {
        headerRef.value.scrollIntoView({ block: "center" });
        currentId.value = id;
        step.value = updatedStep;
        editingSamling.value = !!updatedEditingSamling;
    };

    defineExpose({
        tabId,
        hasUnsavedData,
    });

    onBeforeMount(() => {
        store.commit("lakemedel/addSubscriber");
        store.dispatch("nll/addSubscriber");
    });

    onMounted(() => {
        if (fornya.value) {
            store.commit("tabs/setTabName", { id: tabId.value, name: "Förnya förskrivning" });
        }
    });

    onUnmounted(() => {
        store.commit("lakemedel/removeSubscriber");
        store.dispatch("nll/removeSubscriber");
        store.commit("receptforskrivning/reset");
        emitter.emit("refreshReceptforskrivningar");
    });
</script>

<template>
    <div class="receptforskrivning">
        <div class="header-section" ref="headerRef">
            <div class="header">
                <h2>{{ fornya ? "Förnya förskrivning" : "Ny förskrivning" }}</h2>
                <ReceptforskrivningsmallarButton />
            </div>
            <div class="patientinfo-section">
                <Patientinfo :patientinfo="patientinfo" />
            </div>
        </div>
        <ReceptforskrivningForm
            v-if="step === 'form'"
            ref="formRef"
            :tabId="tabId"
            :receptforskrivningId="currentId"
            @cancel="cancel"
            @submit="onAction"
            @action="onAction"
            :editingSamling="editingSamling"
            :fornya="fornya"
        />
        <ReceptforskrivningDisplay
            v-else-if="step === 'display'"
            :tabId="tabId"
            :receptforskrivningId="currentId"
            @cancel="cancel"
            @action="onAction"
            :editingSamling="editingSamling"
            :fornya="fornya"
        />
        <ReceptforskrivningSamling
            v-else-if="step === 'list'"
            :tabId="tabId"
            @submit="onAction"
            @cancel="cancel"
            @action="onAction"
        />
    </div>
</template>

<style scoped lang="scss">
    .receptforskrivning {
        display: flex;
        flex-direction: column;
        height: 100%;

        .header-section {
            .header {
                display: flex;
                gap: 1.5rem;
            }

            .patientinfo-section {
                margin-bottom: 1.5rem;
            }
        }
    }
</style>
